module.exports = __webpack_public_path__ + "static/media/12.aada7983.jpg";